import React, {useMemo} from 'react';
import {NavLink} from 'react-router-dom';
import ROUTE from '../../../../../../constants/route';
import {DateHelpers} from '../../../../../../helpers/date-helpers';
import {Role} from '../../../../../../helpers/user';
import FeedPostContentFirmLink from '../FeedPostContentFirmLink';

const TypeCandidateMtest = props => {
  const {
    user,
    post: {
      FirmName,
      FirmUrlAlias,
      FirmActive,
      currentSchoolName,
      NewsFeedDateAdd,
      Date,
    },
  } = props;

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        <strong className="feed-post-content__text">GoBuyside Member</strong>
        <div className="feed-post-content__text">from</div>
        <FeedPostContentFirmLink
          isActive={FirmActive === 'Yes'}
          alias={FirmUrlAlias}
          firm={FirmName}
          school={currentSchoolName}
        />
        <div className="feed-post-content__text">just completed the</div>
        {Role.isCandidate(user) &&
        !Role.isCandidateWithRecruiterPosition(user) ? (
          <NavLink to={ROUTE.CANDIDATE_APTITUDE}>
            GoBuyside Aptitude Test
          </NavLink>
        ) : (
          <strong>GoBuyside Aptitude Test</strong>
        )}
      </div>
      <div className="feed-post-content__date">{date}</div>
    </div>
  );
};

export default TypeCandidateMtest;
